'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ModalContainer = require('./ModalContainer.js');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ModalContainer/index.js
// module id = 165
// module chunks = 11